<script>
import JobPostingTable from '@/components/JobPostingTable.vue'
import NoResults from '@/components/NoResults.vue'

export default {
    name: 'RecruitJobs',
    components: {
        JobPostingTable,
        NoResults
    },
    data() {
        return {
            listingsActive: [],
            listingsArchived: [],
            listingsSelected: [],
            loading: true,
        }
    },
    props: {
        companyResource: {
            type: Object,
        },
    },
    methods: {
        async archiveSelected() {
            let promises = []
            let moveToArchiveHandlers = []
            this.listingsSelected.forEach((resource) => {
                resource.set('is_archived', true)
                promises.push(resource.save())
                moveToArchiveHandlers.push(() => {
                    let idx = this.listingsActive.indexOf(resource)
                    this.listingsActive.splice(idx, 1)
                    this.listingsArchived.push(resource)
                })
            })

            await Promise.all(promises)
            moveToArchiveHandlers.forEach((handler) => handler())
            this.listingsSelected = []
        },
    },
    async mounted() {
        let pageResult = await this.companyResource.listings()
        let archived = []
        let active = []

        pageResult.resources.forEach((resource) => {
            if (resource.get('is_archived')) {
                archived.push(resource)
            } else {
                active.push(resource)
            }
        })

        this.listingsArchived = archived
        this.listingsActive = active
        this.loading = false
    },
}
</script>

<template>
    <div v-page-title="'Job Listings'">
        <b-row>
            <b-col md="8" class="section-heading">
                <h4>Job Listings</h4>
            </b-col>
            <b-col md="4" class="text-right">
                <b-button-group>
                    <b-button variant="primary" :to="{ name: 'recruitJobAdd', params: { companyId: companyResource.id } }">List a New Job</b-button>
                </b-button-group>
            </b-col>
        </b-row>

        <b-card no-body class="mt-3">
            <b-tabs card>
                <b-tab :title="`Active and Drafts (${listingsActive.length})`" active>
                    <job-posting-table
                        :listing-resources="listingsActive"
                        v-if="listingsActive.length > 0"
                        v-model="listingsSelected"
                        :actions="[{ text: 'Archive Selected', handler: archiveSelected }]"
                    >
                    </job-posting-table>

                    <b-skeleton-table v-else-if="loading" :rows="5" :columns="4" :table-props="{ bordered: true, striped: true }"></b-skeleton-table>

                    <no-results v-else>
                        <p>You don't currently have any job listings.</p>
                        <p><b-button variant="primary" :to="{ name: 'recruitJobAdd', params: { companyId: companyResource.id } }">List a New Job</b-button></p>
                    </no-results>
                </b-tab>

                <b-tab title="Archive" :disabled="!listingsArchived.length">
                    <job-posting-table :listing-resources="listingsArchived"> </job-posting-table>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<style lang="scss"></style>
